import React from 'react'
import { ExclamationCircleFill } from 'react-bootstrap-icons'

//  TODO: add individual icons somehow
const RequirementIcon= ({
    courseRequirement = {},
    size,
}) => {
    return (
        <ExclamationCircleFill
            size={size}
        />
    )
}

export default RequirementIcon